import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GlobalSearchOrganizationResult } from '@kempoweroyj/ngx-search-api-client';

@Component({
    selector: 'ce-organization-badge',
    templateUrl: './organization-badge.component.html',
    styleUrls: ['./organization-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class OrganizationBadgeComponent {
    @Input() headerStyle = false;
    @Input() globalSearchOrganization: GlobalSearchOrganizationResult;
}
